
export class ProcessItem {
    FirmReference: string;
    ProcessType: string;
    ProcessStatus: string;
    ProductNo: string;
    TotalAmount: Amount;
    ProcessDate: string;
}

export class ProcessDetail {
    ReceiverEmail: string;
    ReceiverTelephoneNo: string;
    ReceiverIdentityNo: string;
    ReceiverSurname: string;
    ReceiverName: string;
    ReceiverCustomerType: string;
    ReceiverIban: string;
    Email: string;
    TelephoneNo: string;
    IdentityNo: string;
    Surname: string;
    Name: string;
    CustomerType: string;
    Iban: string;
    ProcessDate: string;
    TotalAmount: Amount;
    ProductNo: string;
    ProcessStatus: string;
    FirmReference: string; 
    IsThereError: boolean;
}

export class ProcessAction {
    ProcessStateList: ProcessStateList[];
    IsThereError: boolean;
}

export class ProcessStateList {
    Explanation: string;
    ProcessDate: string;
    ProcessState: string;
    ProcessStatus: string;
    ProcessTime: string;
} 

export class Amount {
    Value: number;
    Currency: Currency;
}

export class Currency {
    Name: string;
    Code: string;
    FullName: string;
    ForeignName: string;
    Type: string;
}

export class OldProcessRequest {
    StartDate: string;
    EndDate: string;
    CarNo: string;
}

export class LiveProcessRequest {
    StartDate: string;
    EndDate: string;
}
export class ProcessDetailActionRequest {
    ProcessRef: string;
    IsLive: boolean;
}
export class CancelProcessRequest {
    FirmReference: string;
    CancelReason: string;
}

export class CancelProcessResponse {
    InfoMessageId: number;
    ErrorMessage: string;       
}